import { render, staticRenderFns } from "./StalePositionsTable.vue?vue&type=template&id=412d7c01"
import script from "./StalePositionsTable.vue?vue&type=script&lang=js"
export * from "./StalePositionsTable.vue?vue&type=script&lang=js"
import style0 from "./StalePositionsTable.vue?vue&type=style&index=0&id=412d7c01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports